import * as React from "react";
import {useEffect, useContext, useState} from "react";
import {UserInfo} from "../queries/userInfo";
import {RoleContext} from "../context/roleContext";
import {allowedToPublish, allowedToSubscribe, allowedToOrderService} from "../constant";
import {useAuthentication} from "../../auth/hooks/useAuthentication";

export const useRole = () => {
    const {stateRole, dispatchRole} = useContext(RoleContext);
    const [canPublish, setCanPublish] = useState(false);
    const [canSubscribe, setCanSubscribe] = useState(false);
    const [canOrderService, setCanOrderService] = useState(false);
    const { isAuthenticated } = useAuthentication();
    console.log(stateRole);
    useEffect(() => {
        isAuthenticated && stateRole === false &&
        UserInfo.getRole().then((response) => {
            // if (response.role.some(r=> allowedToPublish.includes(r))) {
            dispatchRole({type: "initRole",payload:response.role});
            // }
        })
    },[])

    useEffect(() => {
        if (stateRole != false) {
            if (allowedToPublish.some((f)=> stateRole.includes(f))) {
                setCanPublish(true);
            } else {
                setCanPublish(false);
            }

            if (allowedToSubscribe.some((f)=> stateRole.includes(f))) {
                setCanSubscribe(true);
            } else {
                setCanSubscribe(false);
            }

            if (allowedToOrderService.some((f)=> stateRole.includes(f))) {
                setCanOrderService(true);
            } else {
                setCanOrderService(false);
            }
        }
    }, [stateRole])

    return {canPublish, canSubscribe, canOrderService}
}
